import { useApiQuery } from '@/shared/hooks/useApi';
import { api } from '@/shared/services/api';

import { KeywordGroupItem } from '../types/productTypes';

const fetchKeywordGroups = async () => {
  return api.get<{ keywordGroupList: KeywordGroupItem[]; totalCount: number }>(
    '/api/v1/keyword/list',
  );
};

export const useKeywordGroups = () => {
  return useApiQuery(['keyword-groups'], fetchKeywordGroups, {
    staleTime: 1000 * 60 * 10,
  });
};
